import { css } from 'emotion';

export const rightSectionStyle = css({
	margin: '36px 0',
	'&:first-child': {
		marginTop: '0',
	},
});



// WEBPACK FOOTER //
// ./src/components/news-and-events/commonSidebar/styles.js